import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'
import { mediaQuery } from '@lacedltd/laced-components'

export const ProductRowWrapper = styled.div({
  paddingTop: tokens.spacing[8],
  // row bleeds to the right edge on mobile to give a more full screen effect
  // margin right should match the right padding on the parent layout
  marginRight: `-${tokens.spacing[6]}`,

  [mediaQuery.m.min]: {
    paddingTop: tokens.spacing[9],
    // removes the bleed effect on desktop
    marginRight: 0
  }
})
